var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg40 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "40")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M70.92,39H69.34C68.06,36,64.21,27.55,59.51,24.82a29.22,29.22,0,0,0-14.7-3.74C39,21.22,31.43,23,28,26.24c-2.68,2.52-6.15,9.43-7.29,12.79H19.18C19,39.26,7.29,41.72,3.83,45.6.16,49.72-.34,60.74,3.15,60.74H14.23c0,.25,0,.5,0,.75,0,4.66,3.42,8.43,7.65,8.43s7.65-3.77,7.65-8.43c0-.25,0-.5,0-.75H61.12c0,.25,0,.5,0,.75,0,4.66,3.43,8.43,7.65,8.43s7.65-3.77,7.65-8.43c0-.25,0-.5,0-.75H86.95c3.49,0,3-11-.68-15.13C82.81,41.72,71.05,39.26,70.92,39Zm-29.3,0H27.78C29,36.35,31,32.76,32.2,31.64s5.14-2.6,9.42-3.19Zm10.29,0H48.06V28.33a22.87,22.87,0,0,1,8.44,2.78c1.68,1,3.91,4.51,5.62,7.93Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg40, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/40.bb62e2d7.svg";
export { ForwardRef as ReactComponent };